module.exports = __webpack_public_path__ + "static/media/tile-reveal.6db99c87.mp3";